var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1812_64760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5311 5.83335C15.8446 4.80584 14.9148 3.96389 13.8244 3.38235C12.734 2.80082 11.5169 2.49772 10.2811 2.50001C9.04748 2.49926 7.83275 2.80312 6.74477 3.38461C5.6568 3.96611 4.72923 4.80725 4.04443 5.83335",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86444 2.5C9.21496 3.5405 8.70346 4.661 8.34277 5.83333",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6978 2.5C11.3478 3.54042 11.8599 4.66091 12.2211 5.83333",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5311 14.1665C15.8446 15.194 14.9148 16.036 13.8244 16.6175C12.734 17.199 11.5169 17.5021 10.2811 17.4998C9.04748 17.5006 7.83275 17.1967 6.74477 16.6152C5.6568 16.0337 4.72923 15.1926 4.04443 14.1665",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86444 17.4998C9.21496 16.4593 8.70346 15.3388 8.34277 14.1665",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6978 17.4998C11.3478 16.4594 11.8599 15.3389 12.2211 14.1665",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94775 8.3335L2.78109 11.6668L4.03109 8.3335L5.28109 11.6668L6.11442 8.3335",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4478 8.3335L15.2811 11.6668L16.5311 8.3335L17.7811 11.6668L18.6144 8.3335",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19775 8.3335L9.03109 11.6668L10.2811 8.3335L11.5311 11.6668L12.3644 8.3335",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1812_64760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.28125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsqIcon);
export default __webpack_public_path__ + "static/media/bsq-icon.48814d55fb9f2df93d626cb0e83adc14.svg";
export { ForwardRef as ReactComponent };